import { render, staticRenderFns } from "./ReductFrequency.vue?vue&type=template&id=83086374&"
import script from "./ReductFrequency.vue?vue&type=script&lang=js&"
export * from "./ReductFrequency.vue?vue&type=script&lang=js&"
import style0 from "./ReductFrequency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports